import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import {importSkuPrice} from '../../../services/api/apiSku'
import {message, Modal as ModalV1} from "antd"
import {CSVLink} from "react-csv"
import {csvData} from "../helper/TemplateImport"

class ImportModal extends Component {
    state = {
        error: '',
        loading: false,
        files: '',
    }

    componentDidMount() {

    }

    _handleChangeFile = (e) => {
        const {files} = e.target
        if (!files || !files[0]) {
            return
        }

        if (!/\.csv$/i.test(files[0].name)) {
            this.setState({
                error: 'Vui lòng chọn file định dạng CSV',
                files: ''
            })
        } else if (files[0].size > 31457280) {
            this.setState({
                error: 'File size is lager than 30M'
            })
        } else {
            this.setState({
                error: '',
                files: files
            })
        }
    }

    _onCancel = () => {
        this.setState({
            files: {}
        })
    }

    _handleSubmit = (e) => {
        e.preventDefault()
        this._onSubmit()
    }

    _onSubmit = async () => {
        const {files} = this.state
        if (!files || !files.length) {
            return this.setState({
                error: 'Vui lòng chọn file cần import'
            })
        }

        const {fetchListSku, onToggleModal} = this.props
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const formData = new FormData()
            formData.append('base_cost_file', files[0])

            const {data: response} = await importSkuPrice(formData)

            const {success, message: error, data} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            const listError = data.filter(item => !item.success)

            this.setState({
                loading: false
            }, () => {
                if(listError.length > 0) {
                    ModalV1.error({
                        title: 'Các bản ghi không thành công',
                        content: (
                            <div className="Errors">
                                <ul>
                                    {
                                        !!listError && listError.length > 0 && listError.map((item, index) => (
                                            <li key={index}>
                                                SKU: {item.sku_name} - {item.sku}
                                                {item.message && <div className="text-danger">{item.message}</div>}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        )
                    })
                } else {
                    message.success('Import thành công.')
                }
                fetchListSku()
                onToggleModal()
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    render() {
        const {isOpen, onToggleModal} = this.props
        const {
            files,
            loading,
            error
        } = this.state

        return (
            <div className="ModalImport">
                <Modal isOpen={isOpen} toggle={onToggleModal}>
                    <ModalHeader toggle={onToggleModal}>Import</ModalHeader>
                    <ModalBody>
                        <div className="ImportTracking">
                            <div className="AttachFile">
                                <input
                                    id={`import_select_file`}
                                    type="file"
                                    accept='text/csv'
                                    multiple={false}
                                    onChange={this._handleChangeFile}
                                    onClick={this._onChangeFile}
                                />
                                <label htmlFor={`import_select_file`} id={`import_select_file`}
                                       className='d-block mb-0 cursor-pointer'>
                                    <i className="fa fa-cloud-upload"/> Chọn file cần import
                                </label>
                            </div>
                            {files && <div className="ListFileInput mt-3">
                                <ul>
                                    <li className="mb-3">
                                        <div className="Left">
                                            <i className="fa fa-paperclip"/>
                                            <span className="FileName">{files[0].name}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>}
                        </div>
                        <div className="Template mt-2">
                            <span>Bạn có thể tải file template tại </span>
                            <CSVLink
                                data={csvData}
                                filename={"price_template.csv"}
                                className=""
                            >
                                đây
                            </CSVLink>
                        </div>
                        {error && <div className="text-danger mt-3">{error}</div>}
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-between">
                        <button className="btn btn-secondary" color="secondary" onClick={onToggleModal}>Hủy</button>
                        <button disabled={loading} onClick={this._handleSubmit} className="btn btn-primary">{loading &&
                        <i className='fa fa-spin fa-spinner mr-2'/>} Thêm mới
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

}

ImportModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onToggleModal: PropTypes.func.isRequired
}

export default ImportModal
